import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-shrink-0 overflow-hidden bg-trader-gray dark:rounded p-2" }
const _hoisted_2 = { class: "flex justify-center gap-2" }
const _hoisted_3 = { class: "text-nowrap items-center flex flex-grow" }

import {ref} from 'vue'
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRSelect from "@/components/Base/v2/TRSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TRTablePager',
  props: {
  numberOfData: Number,
  onPageStep: Function,
  dataLength: Number,
},
  setup(__props) {

const PageNavigation = {
  PLUS: 1,
  MINUS: -1,
  START: 0,
  END: 2,
};

const count = ref(1);
const props = __props;

function changeCount(type: number) {
  if (type === PageNavigation.PLUS) {
    if (count.value < props.numberOfData) {
      count.value += 1;
      props.onPageStep(count.value);
    }
  } else if (type === PageNavigation.MINUS) {
    if (count.value > 1) {
      count.value -= 1;
      props.onPageStep(count.value);
    }
  } else if (type === PageNavigation.START) {
    count.value = 1;
    props.onPageStep(count.value);
  } else if (type === PageNavigation.END) {
    count.value = props.numberOfData;
    props.onPageStep(count.value);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TRButton, {
        class: "w-10 flex-shrink-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeCount(PageNavigation.START))),
        icon: "fa-solid fa-backward-step"
      }),
      _createVNode(TRButton, {
        class: "w-10 flex-shrink-0",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeCount(PageNavigation.MINUS))),
        icon: "fa-solid fa-angle-left"
      }),
      _createVNode(TRButton, {
        class: "w-10 flex-shrink-0",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeCount(PageNavigation.PLUS))),
        icon: "fa-solid fa-angle-right"
      }),
      _createVNode(TRButton, {
        class: "w-10 flex-shrink-0",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeCount(PageNavigation.END))),
        icon: "fa-solid fa-forward-step"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Seite " + _toDisplayString(count.value) + "/" + _toDisplayString(props.numberOfData), 1)
      ])
    ])
  ]))
}
}

})